import { render } from "./TlbsCommitmentAgreementComponent.vue?vue&type=template&id=19dccdfb&scoped=true&ts=true"
import script from "./TlbsCommitmentAgreementComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsCommitmentAgreementComponent.vue?vue&type=script&lang=ts"

import "./TlbsCommitmentAgreementComponent.vue?vue&type=style&index=0&id=19dccdfb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dccdfb"]])

export default __exports__